import { useEffect } from 'react';
import { useUserStats } from '../hooks/useUserStats';
import { useAuthStore } from '../stores/authStore';
import { useAssessmentStore } from '../stores/assessmentStore';
import { queueProfileStatsMirror } from '../lib/profileStatsMirror';

/**
 * Invisible app-level worker: keeps the user_profiles stats mirror
 * (level/XP/domain levels/assessment summary) in step with the client-computed
 * truth so Connect profiles can show it cross-user. Renders nothing.
 */
export function ProfileStatsMirror() {
  const userId = useAuthStore(s => s.user?.id ?? null);
  const { stats } = useUserStats();
  const assessments = useAssessmentStore(s => s.assessments);
  const attemptHistory = useAssessmentStore(s => s.attemptHistory);
  const latestResults = useAssessmentStore(s => s.latestResults);

  useEffect(() => {
    if (userId) queueProfileStatsMirror({ userId, stats, assessments, attemptHistory, latestResults });
  }, [userId, stats, assessments, attemptHistory, latestResults]);

  return null;
}
